import React from 'react';
import styled from 'styled-components';

const LinkButton = styled.span`
  color: inherit;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

export default ({ href, children, ...rest }) => (
  <LinkButton
    {...rest}
    onClick={() => {
      if (window.OFFER) {
        window.open(href, '_blank');
      } else {
        window.location = href;
      }
    }}
  >
    {children}
  </LinkButton>
);

function handleTitleClick(event) {
  event.preventDefault();
  const element = event.target;
  if (element.tagName === 'A') {
    if (window.DATA) {
      window.open(element.href, '_blank');
    } else {
      window.location = element.href;
    }
  }
}

export const HTMLSectionWithLink = styled(({ children, className }) => (
  <div
    className={className}
    dangerouslySetInnerHTML={{ __html: children }}
    onClick={handleTitleClick}
  />
))`
  a {
    color: inherit;
    cursor: pointer;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`;
